import { FC } from "react";

import cx from "apps/website/utils/misc/cx";
import { Theme, themeRootClassMap } from "apps/website/maps/Theme.map";

export type ArrowAlign = "start" | "center" | "end";
export type ArrowTheme = Extract<Theme, "light" | "mid-green" | "green" | "sand-200" | "light-grey" | "dark">;
export const arrowThemeOptions: ArrowTheme[] = [ "light", "mid-green", "green", "sand-200", "light-grey", "dark" ];

export const arrowSizeMap = { small: 13, large: 21 };

const alignMap: Record<ArrowAlign, string> = {
  start: "left-4",
  center: "left-1/2 -translate-x-1/2",
  end: "right-4",
};
export type ArrowSize = keyof typeof arrowSizeMap;

export interface ArrowIndicatorProps {
  visible?: boolean;
  size?: ArrowSize;
  align?: ArrowAlign;
  offsetPx?: number;
  backgroundColour?: ArrowTheme;
  styleOptions?: {
    top?: number;
  };
}

export const ArrowIndicator: FC<ArrowIndicatorProps> = ({
  visible = true,
  size = "small",
  align = "center",
  offsetPx,
  backgroundColour = "light",
  styleOptions,
}) => {
  if (!visible) {
    return null;
  }

  const px = arrowSizeMap[size];
  const backgroundClass = themeRootClassMap[backgroundColour];

  return (
    <div
      aria-hidden="true"
      className={cx(
        "absolute",
        backgroundClass,
        offsetPx === undefined ? alignMap[align] : undefined,
      )}
      style={{
        width: px,
        height: px,
        top: styleOptions?.top ?? 0,
        left: offsetPx,
        transform: "translateY(-50%) rotate(45deg)",
      }}
    />
  );
};
